module.exports = __webpack_public_path__ + "img/logo.330a7ec9.png";